export default "__VITE_ASSET__DdEfocq2__"